import { Component, OnInit, ElementRef, Directive, Input, ViewChild, ViewChildren } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { PreferenceService } from '../../Services/preferenceservice.service';
import { CheckAuth } from '../../Services/UtilityService';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BlockUIModule } from 'primeng/blockui';
//import { debounce } from 'rxjs/operator/debounce';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
  templateUrl: './AddPlanBasic.component.html'
})

export class AddPlanBasic implements OnInit {

  ngOnInit() { }

}
